<form [formGroup]="form">
  <div class="request-exchange-search-container">
    <!-- div class="col-sm-3" -->
    <div class="request-exchange-search-input-container">
      <div class="input-group-container">
        <input
          class="request-exchange-search__input request-exchange-search__input--full-width"
          [ngClass]="{ 'form__input--info': form.get('dealNbr').hasError('sfRemicError') }"
          [ngClass]="{ 'form__input--info': form.get('dealNbr').hasError('smbsError') }"
          [ngClass]="{ 'form__input--info': form.get('dealNbr').hasError('mfRemicError') }"
          [ngClass]="{ 'form__input--info': form.get('dealNbr').hasError('bmRemicError') }"
          id="inputCusip"
          formControlName="dealNbr"
          type="text"
          placeholder="{{ hint }}"
          name="dealOrCusip"
          maxlength="9"
          [(ngModel)]="usrInput"
          autocomplete="off"
          required
        />

        <ng-container *ngIf="form.get('dealNbr').hasError('sfRemicError')">
          <i
            class="fa fa-info-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon--float--right tooltip-error"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Enter Deal(ex.2016-001) or CUSIP"
          ></i>
        </ng-container>

        <ng-container *ngIf="form.get('dealNbr').hasError('smbsError')">
          <i
            class="fa fa-info-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon--float--right tooltip-error"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Enter Trust(ex. 100) or CUSIP"
          ></i>
        </ng-container>

        <ng-container *ngIf="form.get('dealNbr').hasError('mfRemicError')">
          <i
            class="fa fa-info-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon--float--right tooltip-error"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Enter Deal(ex.2016-M01) or CUSIP"
          ></i>
        </ng-container>

        <ng-container *ngIf="form.get('dealNbr').hasError('bmRemicError')">
          <i
            class="fa fa-info-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon--float--right tooltip-error"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Enter Deal(ex.2016-B01) or CUSIP"
          ></i>
        </ng-container>
      </div>
    </div>

    <!-- /div -->

    <!-- div class="col-sm-2" -->

    <button
      (click)="onDealSearch()"
      class="btn request-exchange-search__button request-exchange-search__button--full-width"
      [class.formInvalid]="form.get('dealNbr').hasError('sfRemicError')"
      [class.formInvalid]="form.get('dealNbr').hasError('smbsError')"
      [class.formInvalid]="form.get('dealNbr').hasError('mfRemicError')"
      [class.formInvalid]="form.get('dealNbr').hasError('bmRemicError')"
      type="button"
    >
      Apply
    </button>

    <!-- /div -->
  </div>
</form>
